"use client";
import { SingleProduct } from "@/__generated__/graphql";
import { sendGAEvent, sendGTMEvent } from "@next/third-parties/google";
import { useEffect } from "react";

type Props = {
  product: SingleProduct;
};

export default function GoogleAnalyticsProductViewEvent(props: Props) {
  const variant = props.product.variants && props.product.variants.length > 0 ? props.product.variants[0] : null;
  useEffect(() => {
    // ارسال رویداد "view_item" به Google Analytics
    sendGAEvent("event", "view_item", {
      currency: "USD",
      value: variant?.price ?? null,
      items: [
        {
          item_name: props.product.title, // نام محصول
          item_id: props.product.code, // شناسه محصول
          value: variant?.price ?? null,
        },
      ],
    });
  }, [props.product]);

  return <></>;
}
